import { Component, EventEmitter, OnInit, ViewChild, ElementRef, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { SharedService } from 'projects/services/src/app/shared/shared.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { CandidateAttendanceService } from 'projects/services/src/app/API/candidate-attendance.service';
declare var toastr: any;
declare var swal: any;
import * as moment from 'moment';
import { FileService } from 'projects/services/src/app/API/document/file.service';

const STRING = Object.freeze({
	EMPTY_STRING: '',
	THREE_DOT: '...',
	COMMA_SPACE: ', ',
	FORWARD_SLASH: '/',
	UNDERSCORE: '_'
});
@Component({
	selector: 'app-batch-attendence',
	templateUrl: './batch-attendence.component.html',
	styleUrls: ['./batch-attendence.component.css']
})
export class BatchAttendenceComponent implements OnInit {
	batchId: string; // Popuated from params
	// File Upload Variables
	fileUpload: any; // Multipart/formData Variable
	selectedUploadFile: any; // selected file to be uploaded
	placeholder = 'Select Excel File to upload'
	// Flags
	activateDownload = true;
	showUploadTick = false; // show uploaded green tick falg
	disableUpload = false;
	orderForm: FormGroup;
	fileSizeError = false;
	// actiavate
	// Multiselect config variable
	settings: any;
	// dropdown Data
	jobRoles: any = []; // Job roles data
	jobRoleDropDownData: any[] = [] // Mapped data of Job roles for dropdown
	selectedItemsJobRole: any = []; // selected Job roles array
	// Table Variables
	Data: any[] = [];
	data2: any[] = [];
	showAttendanceVariable = false;
	// Additional Documents
	additionalDocFilesUploaded: any[] = [];
	filesUploadedS3Urls: any[] = [];
	showSupportingDocs = false;
	// Form variable
	attendanceForm: FormGroup; // Attendance Form Variable
	fileName: any;
	fileTypeError = false;
	filename: any;
	attendenceMode: any;
	routerInfo: {
		params: any,
		queryParams: any
	} = {
			params: {},
			queryParams: {}
		};
	flterForm: FormGroup
	currentBatchJobRoles: any = [];
	selectedJobRole: any = "default";
	modelObj = {
		date: null,
		jobRole: null,
	};
	statusColor = {
		'A': '#D73D31',
		'P': '#A5D300',
		'Completed': '#417505',
		'Dropout': '#D0021B',
		'Lateral': '#F5A623'


	};


	monthArray: any = [{
		'name': 'January',
		'value': 1
	},
	{
		'name': 'February',
		'value': 2
	},
	{
		'name': 'March',
		'value': 3
	},
	{
		'name': 'April',
		'value': 4
	},
	{
		'name': 'May',
		'value': 5
	},
	{
		'name': 'June',
		'value': 6
	},
	{
		'name': 'July',
		'value': 7
	},
	{
		'name': 'August',
		'value': 8
	},
	{
		'name': 'September',
		'value': 9
	},
	{
		'name': 'October',
		'value': 10
	},
	{
		'name': 'November',
		'value': 11
	},
	{
		'name': 'December',
		'value': 12
	}
	]

	dates: any;
	items: FormArray;
	jobRole: any;
	nonFormatDate: any;
	batchStartDate: any;
	candidateArray: any = [];
	dataHeader: any = []
	dateArray: any = [];
	nonFormatBatchEndDate: any;
	tableHeaderData: any = [];
	attendenceByDate: any = [];
	batchAttendenceArray: any = [];
	showTable: boolean;
	supportingDoc: any;
	monthFilter: FormGroup;
	todayDateValue = new Date();
	holidayDate: any;
	// jobRolePlaceholder: any = "Select Job Role"
	constructor(
		private fb: FormBuilder,
		private batchService: BatchService,
		private activatedRoute: ActivatedRoute,
		private formBuilder: FormBuilder,
		private fileService: FileService,
		private sanitizer: DomSanitizer,
		private candidateAttendanceService: CandidateAttendanceService,
		private sharedService: SharedService
	) {
		this.orderForm = this.formBuilder.group({
			items: this.formBuilder.array([this.createItem()]),
		});
	}


	ngOnInit() {
		this.flterForm = this.formBuilder.group({
			jobRole: ['', [Validators.required]],
			date: ['', [Validators.required]],

			// addressProof:  {value: this.assessmentData &&  this.assessmentData.address &&  this.assessmentData.address.proof.addressProof || 'N/A',  disabled: true},
		})
		this.monthFilter = this.formBuilder.group({
			month: ['', [Validators.required]]
		})

		this.createAttendanceForm().then((res) => { this.getJobRolesForABatch() });
		this.activatedRoute.parent.data.subscribe(data => {
			console.log(data, 'change data batch');
			const elements = (data.batch.jobRoles) || [];
			const mapElements = elements.map(element => ({
				jobRoleName: element.jobName,
				qpCode: element.qpCode
			}))

			const canElements = (data.batch && data.batch.candidates) || [];
			const mapCanElements = canElements.map(element => ({
				candidateName: element.firstName,
				canId: element.userName
			}))
			Helpers.copyArray(this.candidateArray, mapCanElements);
			console.log(this.candidateArray);
			this.flterForm.controls.jobRole.patchValue(data.batch.jobRoles[0].qpCode);
			Helpers.copyArray(this.currentBatchJobRoles, mapElements)
			console.log(this.currentBatchJobRoles);
			this.attendenceMode = data.batch.attendanceMode
			this.batchId = data.batch.batchId;
			this.dates = Helpers.formatDateToView(data.batch.batchStartDate);
			this.nonFormatDate = data.batch.batchStartDate
			this.nonFormatBatchEndDate = data.batch.batchEndDate;
		})
		// this.getAttendenceForBatch();
		const todayDate = new Date().toISOString();

		// if (new Date(this.nonFormatBatchEndDate).getTime() > new Date(todayDate).getTime()) {
		// 	this.getDates(this.nonFormatDate, todayDate);
		// } else {
		this.getDates(this.nonFormatDate, this.nonFormatBatchEndDate);
		// }
		this.addItem();

		this.patchValue();
		this.getAllAttendenceForBatch();
		this.getDateTableHeader();


	}
	convertString(data) {
		// if (data) {
		// 	for (let index = 0; index < this.tableHeaderData.length; index++) {
		// 		// return Helpers.formatDateToView(data[index].attDates)
		// 		for (let j = 0; j < this.tableHeaderData[index].date.length; j++) {
		// 			return this.tableHeaderData[index].attDates
		// 		}

		// 	}
		// }
	}

	formatDate(resDate) {
		const date = new Date(resDate);
		const formattedDate = date.toLocaleDateString('en-GB', {
		day: 'numeric', month: 'short', year: 'numeric'
		}).replace(/ /g, '-');
		console.log(formattedDate);
		return formattedDate;
	}

	getHolidaysData() {
		let selectedDate = this.flterForm.value.date
		this.candidateAttendanceService.getholidayDay(this.batchId).subscribe(res => {
			for (let index = 0; index < res.length; index++){
				for (let indexx = 0; indexx < res[index].sessions.length; indexx++) {

					// console.log(res[index].sessions[indexx].dateAndDay);
					// console.log(selectedDate);
					if (this.formatDate(res[index].sessions[indexx].dateAndDay) === selectedDate) {
						this.holidayDate = Helpers.formatDateToView(res[index].sessions[indexx].dateAndDay);
						console.log(res[index].sessions[indexx].dateAndDay);
					}
				}
			}
		})
	}


	getDateTableHeader() {
		this.candidateAttendanceService.getTableHeader(this.flterForm.value.jobRole, this.batchId, this.candidateArray[0].canId).subscribe(res => {
			console.log(res);
			if (res) {
				Helpers.copyArray(this.tableHeaderData, res[0].attDates)

			} else {
				Helpers.copyArray(this.tableHeaderData, []);
			}


		})
	}



	// resetForm() {
	// 	for (let index = 0; index < this.candidateArray.length; index++) {
	// 		this.orderForm.get('items')['controls'][index].controls.candidateId.value = this.candidateArray[index].canId;
	// 		this.orderForm.get('items')['controls'][index].controls.candidateName.value = this.candidateArray[index].candidateName
	// 		this.orderForm.get('items')['controls'][index].controls.startDate.value = this.flterForm.value.date;
	// 		this.orderForm.get('items')['controls'][index].controls.attendanceStatus.value = '';
	// 		this.orderForm.get('items')['controls'][index].controls.status.value = '';



	// 	}

	// }
	createItem(): FormGroup {
		return this.formBuilder.group({
			candidateId: '',
			candidateName: {
				value: '',
				disabled: true
			},
			startDate: [[Validators.required]],
			attendanceStatus: ['', [Validators.required]],
			status: ['', [Validators.required]],
			percentage: {
				value: `0%`,
				disabled: true,
			},
		});

	}

	addItem() {

		this.items = this.orderForm.get('items') as FormArray;
		for (let index = 1; index < this.candidateArray.length; index++) {
			this.items.push(this.createItem());
		}

	}
	patchValue() {
		// if (this.attendenceByDate.length === 0) {
		for (let index = 0; index < this.candidateArray.length; index++) {
			this.orderForm.get('items')['controls'][index].controls.candidateId.value = this.candidateArray[index].canId;
			this.orderForm.get('items')['controls'][index].controls.candidateName.value = this.candidateArray[index].candidateName
			this.orderForm.get('items')['controls'][index].controls.startDate.value = this.flterForm.value.date
			// percentage
			// console.log(this.orderForm.get('items')['control'][index].controls.candidateId.value)
			// attendenceByDate

		}
		// }

		if (this.attendenceByDate.length > 0) {
			console.log('first condition');

			for (let j = 0; j < this.attendenceByDate.length; j++) {

				if (this.attendenceByDate[j].attendence) {
					console.log('attendence');
					// "candiateName": element.candidateName,
					// "candidateId": element.candidateId,
					for (let k = 0; k < this.attendenceByDate[j].attendence.length; k++) {
						this.orderForm.get('items')['controls'][j].controls.candidateId.value = this.attendenceByDate[j].candidateId;
						this.orderForm.get('items')['controls'][j].controls.candidateName.value = this.candidateArray[j].candidateName
						this.orderForm.get('items')['controls'][j].controls.startDate.value = this.flterForm.value.date
						this.orderForm.get('items')['controls'][j].controls.status.value = this.attendenceByDate[j].status;
						this.orderForm.get('items')['controls'][j].controls.percentage.value = this.attendenceByDate[j] && this.attendenceByDate[j].percentage || '0%'
						this.orderForm.get('items')['controls'][j].controls.attendanceStatus.value = this.attendenceByDate[j].attendence[k].attendenceStatus

					}
				} else if (!this.attendenceByDate[j].attendence) {
					console.log('no attendence');
					this.orderForm.get('items')['controls'][j].controls.candidateId.value = this.attendenceByDate[j].candidateId;
					this.orderForm.get('items')['controls'][j].controls.percentage.value = '0%'
					this.orderForm.get('items')['controls'][j].controls.candidateName.value = this.candidateArray[j].candidateName
					this.orderForm.get('items')['controls'][j].controls.startDate.value = this.flterForm.value.date
					this.orderForm.get('items')['controls'][j].controls.attendanceStatus.value = '';
					this.orderForm.get('items')['controls'][j].controls.status.value = '';


				} else {
					console.log('here');

				}
			}
		}

		console.log(this.orderForm);

	}
	getTemplateForJobRole() {
		const attendanceformdata = this.attendanceForm.value;
		this.batchService.excelDownloadForAJobRole(this.batchId, attendanceformdata.jobRole[0].id).subscribe(res => {
			this._downloadFile(res);
			console.log('file downloaded')
		}), err => {
			toastr.error('Could not get job roles for batch');
		}
	}

	disableAllFields() {
			for (let index = 0; index < this.candidateArray.length; index++) {
				this.orderForm.get('items')['controls'][index].controls.get('candidateId').disable();
				this.orderForm.get('items')['controls'][index].controls.get('candidateName').disable();
			// percentage
			// console.log(this.orderForm.get('items')['control'][index].controls.candidateId.value)
			// attendenceByDate

		}
	}

	getDates(startDate, stopDate) {
		let dateArray = [];
		let currentDate = moment(startDate);
		let stopDates = moment(stopDate);
		while (currentDate <= stopDates) {
			dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
			currentDate = moment(currentDate).add(1, 'days');
		}
		this.dateArray = dateArray
		return dateArray;
	}

	getDateValidationFuture(date): boolean {
		const givenDate = new Date(date);
		return this.todayDateValue.getTime() < givenDate.getTime()
	}

	mapPayLoad() {
		console.log(this.orderForm);

		const elements = (this.orderForm.getRawValue().items) || [];
		const mapElements = elements.map(element => ({
			"candidateName": element.candidateName,
			'candidateId': element.candidateId,
			"status": element.status || 'N/A',
			'batchId': this.batchId,
			"jobRole": this.flterForm.value.jobRole,
			"attendence": this.dateMapLoad(element.attendanceStatus, this.flterForm.value.date),
			// [
			// 	{
			// 		"date": new Date(this.flterForm.value.date).toISOString(),
			// 		"attendenceStatus": element.attendanceStatus
			// 	}
			// ],
			"trainingStartDate": new Date(this.nonFormatDate).toISOString(), // you neeed to send these  two dates for making attendence
			'trainingEndDate': new Date(this.nonFormatBatchEndDate).toISOString()
		}))

		console.log(mapElements);
		return mapElements


	}

	dateMapLoad(status, date) {
		console.log(status);

		const tempArray: any = [];
		for (let index = 0; index < this.dateArray.length; index++) {
			if (date === this.dateArray[index]) {

					const Data = {
						'date': new Date(this.dateArray[index]).toISOString(),
						'attendenceStatus': status || 'N/A'
					}
					tempArray.push(Data);


			}
			else {
				const Data = {
					'date': new Date(this.dateArray[index]).toISOString(),
					'attendenceStatus': status || 'N/A'

				}
				tempArray.push(Data);
			}

		}
		return tempArray;
	}

	mapKeyDaya(data) {
		if (data)
			for (let index = 0; index < this.dateArray.length; index++) {
				for (let j = 0; j < data.length; j++) {
					if (this.dateArray[index] === data[j].date) {
						console.log(data[j]);
						return data[j]
					}
				}
			}
	}

	save() {
		console.log(this.orderForm.value.items);
		console.log(this.mapPayLoad());
		this.candidateAttendanceService.addCandidateAttendance(this.batchId, this.flterForm.value.jobRole, this.mapPayLoad()).subscribe(res => {
			if (res) {
				swal(`Document Submitted Successfully `, '', 'success').then(() => {
				});
				this.getAllAttendenceForBatch();
				this.getDateTableHeader();
				this.showTable = false;

			}
		})
	}

	submit() {
		const DATA = {
			'jobRole': this.flterForm.value.jobRole,
			'batchId': this.batchId,
			'status': 'Attendence Submitted'

		}
		this.candidateAttendanceService.submitAttendance(DATA).subscribe(res => {
			if (res) {
				swal(`Attendance Submitted Successfully `, '', 'success').then(() => {
				});
				this.getAllAttendenceForBatch();
				this.getDateTableHeader();
				this.showTable = false;

			}
		})

	}

	submitPayloadData() {
		const DATA = {
			'jobRole': this.flterForm.value.jobRole,
			'batchId': this.batchId,
			'supportingDocs': this.attendanceForm.value.supportingDocuments.supportingDocs
		}
		return DATA;
	}

	submitDocument() {
		if (this.batchAttendenceArray.length === 0) {
			toastr.error('Cannot submit document, save attendence and try again')
			return;
		} else if (this.attendanceForm.value.supportingDocuments.supportingDocs) {
			this.candidateAttendanceService.uploadSupportingDocument(this.submitPayloadData()).subscribe(res => {
				if (res) {
					swal(`Attendance Submitted Successfully `, '', 'success').then(() => {

					});
					this.getAllAttendenceForBatch();
					this.getDateTableHeader();
				} else {
					return;
				}
			})
		}
		else {
			toastr.error('Please upload document')
		}

	}

	resetFilter() {
		this.flterForm = this.formBuilder.group({
			jobRole: ['', [Validators.required]],
			date: ['', [Validators.required]]
			// addressProof:  {value: this.assessmentData &&  this.assessmentData.address &&  this.assessmentData.address.proof.addressProof || 'N/A',  disabled: true},
		})

	}
	getPercentage(value) {
		if (value) {
			const totalAcquire = value.length / value.length;
			const percentage = totalAcquire * 100
			return `${percentage}%`
		} else {
			return `0%`
		}

	}
	getAllAttendenceForBatch() {
		const myArray: any = [];
		const att: any = []
		const len = this.dateArray.length;
		const isoFromDate = new Date(this.nonFormatDate).toISOString();
		const isoEndDate = new Date(this.nonFormatBatchEndDate).toISOString();


		this.candidateAttendanceService.getBatchAttendence(this.batchId, this.flterForm.value.jobRole, isoFromDate, isoEndDate).subscribe(res => {
			if (res) {
				const elements = (res) || [];
				const mapElements = elements.map(element => ({
					'candiateName': element.candidateName,
					'candidateId': element.candidateId,
					'supportingDocs': element.supportingDocs,
					'attendence': element.attendence,
					'status': element.status,
					'percentage': this.roundNumber(element.percentage)

				}));
				this.batchAttendenceArray = mapElements;
				console.log(mapElements);
				for (let index = 0; index < this.batchAttendenceArray.length; index++) {
					if (this.batchAttendenceArray[index].supportingDocs) {
						this.supportingDoc = this.batchAttendenceArray[0].supportingDocs
					}
				}
			}
		})

	}
	roundNumber(data) {
		if (data) {
			return `${Math.round(data)}%`
		} else {
			return '0%'
		}
	}

	privewDocument(docUrl) {
		this.fileService.downloadAttachedFile(docUrl);
	}

	getAttendenceByDate() {
		const myArray: any = [];
		const att: any = []
		const len = this.dateArray.length;
		const today = new Date(this.flterForm.value.date);
		const yesterday = new Date(today);
		const ys = yesterday.setDate(today.getDate() - 1);
		this.candidateAttendanceService.getBatchAttendence(this.batchId, this.flterForm.value.jobRole, new Date(ys).toISOString(), new Date(this.flterForm.value.date).toISOString()).subscribe(res => {
			if (res) {
				const elements = (res) || [];
				const mapElements = elements.map(element => ({
					'candiateName': element.candidateName,
					'candidateId': element.candidateId,
					'attendence': element.attendence,
					'status': element.status,
					'percentage': this.roundNumber(element.percentage)

				}));
				this.attendenceByDate = mapElements;
				console.log(this.attendenceByDate);
			}
		})

	}
	getDate(data) {
		for (let index = 0; index < data.attendence.length; index++) {
			console.log(data.attendence[index].date);

			return Helpers.formatDateToView(data.attendence[0].date)
		}

	}
	previewSheet() {
		Helpers.openModal('att-sheet')
	}
	applyFilter() {
		console.log(this.flterForm.value);
	}
	// To make the fie download on the same Page
	private _downloadFile(data: any) {
		let fileUrl;
		fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
		// window.open(fileUrl.changingThisBreaksApplicationSecurity);
		const a = document.createElement('a');
		a.href = fileUrl.changingThisBreaksApplicationSecurity;
		// a.download = fileUrl.changingThisBreaksApplicationSecurity;
		a.download = 'Candidates.xls';
		document.body.appendChild(a);
		a.click();
	}

	removeFile(index) {
		this.additionalDocFilesUploaded.splice(index, 1);
		this.filesUploadedS3Urls.splice(index, 1)
		console.log('file', this.additionalDocFilesUploaded, this.filesUploadedS3Urls)
	}



	// reinitilize values
	reInit() {
		this.showUploadTick = false;
		this.additionalDocFilesUploaded = [];
		this.filesUploadedS3Urls = [];
		this.showSupportingDocs = false;
		this.selectedUploadFile = []
		this.showAttendanceVariable = false;
		this.sharedService.submitToSSC.next(true);
	}

	getJobRolesForABatch() {
		this.batchService.getJobroleForbatch(this.batchId).subscribe(res => {
			if (res.Qpcodes.length > 0) {
				this.jobRoleDropDownData = res.Qpcodes.map(qp => {
					return {
						'id': qp.qpCode,
						'itemName': qp.jobName
					}
				})
			}
		});
	}
	private createAttendanceForm() {
		return new Promise((resolve, reject) => {
			this.attendanceForm = this.fb.group({
				jobRole: [[], Validators.required],
				uploadFile: [
					'',
					[
						Validators.required,
						ValidationService.fileSizeValidator(5),
						// ValidationService.fileTypeValidator('xls,xlsx')
					]
				],
				supportingDocuments: this.fb.group({
					// tslint:disable-next-line:max-line-length
					supportingDocs: [[], [ValidationService.fileValidator, ValidationService.fileTypeValidator('pdf', 'doc', 'jpeg', 'jpg', 'png', 'xls', 'xlsx'), ValidationService.fileSizeValidator(5)]]
				}),
			})
			return resolve(true);
		})

	}
	// function called to populate the downoaded file
	selectedFile(event) {
		this.showUploadTick = false;
		this.selectedUploadFile = event.target.files;
		const filetype = this.selectedUploadFile[0] ? this.selectedUploadFile[0].name.split('.').pop() : '';
		if (filetype && (filetype !== ('xls'))) {
			this.fileTypeError = true;
			this.placeholder = 'Select Excel File to upload';
			// toastr.error('Please Select Appropriate File');
		} else {
			this.fileTypeError = false;
			console.log(this.selectedUploadFile[0], this.selectedUploadFile[0].name.split('.').pop());
			if (this.selectedUploadFile) {
				this.filename = this.selectedUploadFile[0].name;
				if (this.selectedUploadFile[0].size < 5000000) {
					this.placeholder = this.selectedUploadFile[0].name;
					this.fileSizeError = false;
					if (this.selectedUploadFile.length > 0) {
						if (this.selectedUploadFile[0].size) {
							if (this.selectedUploadFile[0].size / 1024 / 1024 > 5) {
								this.fileSizeError = true;
							} else {
								this.fileSizeError = false;
							}
						}
						if (this.selectedUploadFile[0].name) {
							this.placeholder = this.selectedUploadFile[0].name;
						} else {
							this.placeholder = 'Select Excel File to upload'
						}
					} else {
						this.placeholder = 'Select Excel File to upload'
					}
				} else {
					this.placeholder = 'Select Excel File to upload'
					this.fileSizeError = true;
				}
			} else {
				this.placeholder = 'Select Excel File to upload'
			}
		}
	}

	// Upload File in multipart

	// s3 uploaded Files
	setFileUploaded() {
		console.log(this.attendanceForm.value);
		const attendanceformdata = this.attendanceForm.value;
		const filesUploaded = attendanceformdata.supportingDocuments.supportingDocs;
		// this.additionalDocFilesUploaded = attendanceformdata.supportingDocuments.supportingDocs;
		// if (filesUploaded.length > 0) {
		// 	for (let i = 0; i < filesUploaded.length; i++) {
		// 		this.filesUploadedS3Urls.push(filesUploaded[i])
		// 		const fileName = this._deriveNameFromS3Url(filesUploaded[i]);
		// 		this.additionalDocFilesUploaded.push(fileName);
		// 	}
		// 	this.showSupportingDocs = true;
		// }

		// this.attendanceForm.get('supportingDocuments').get("supportingDocs").setValue("");
		console.log(this.attendanceForm);
		console.log(this.additionalDocFilesUploaded);
	}
	// private _deriveNameFromS3Url(s3Url) {
	// 	const s3UrlData = s3Url.split(STRING.FORWARD_SLASH);
	// 	const fullName = s3UrlData[s3UrlData.length - 1];
	// 	const nameData = fullName && fullName.split(STRING.UNDERSCORE);
	// 	nameData.splice(0, 1);
	// 	const name = nameData.join(STRING.UNDERSCORE);
	// 	// const name = nameData &&  nameData[nameData.length - 1];
	// 	return name;
	// }


	clearForm() {

		console.log('form array cleared');
		this.orderForm = this.formBuilder.group({
			items: this.formBuilder.array([this.createItem()]),
		});
		this.getAttendenceByDate();
		this.addItem();
		this.patchValue();
		this.patchValue();
		this.getHolidaysData();
		this.showTable = true;
		if (this.attendenceMode === 'not applicable') {
			for (let index = 0; index < this.candidateArray.length; index++) {
				this.orderForm.get('items')['controls'][index].get('attendanceStatus').disable()
				this.orderForm.get('items')['controls'][index].get('status').disable()
			}
		}

	}
	mirrorFuncForm() {

		console.log('form array cleared');
		this.orderForm = this.formBuilder.group({
			items: this.formBuilder.array([this.createItem()]),
		});
		this.getAttendenceByDate();
		this.addItem();
		this.patchValue();
		this.patchValue();
		this.showTable = false;

	}

	filterAttendenceByMonth() {
		console.log(this.monthFilter.value)
		const currentYear = new Date().getFullYear()
		const firstDay = new Date(new Date().getFullYear(), this.monthFilter.value.month, 1);
		const lastDay = new Date(new Date().getFullYear(), this.monthFilter.value.month + 1, 0);
		console.log('First Day ', firstDay.toISOString());
		console.log('Last Day ', lastDay.toISOString());
		this.candidateAttendanceService.getBatchAttendence(this.batchId, this.flterForm.value.jobRole, firstDay.toISOString(), lastDay.toISOString()).subscribe(res => {
			if (res) {
				const elements = (res) || [];
				const mapElements = elements.map(element => ({
					'candiateName': element.candidateName,
					'candidateId': element.candidateId,
					'attendence': element.attendence,
					'status': element.status,
					'percentage': this.getPercentage(element.attendence)

				}));
				this.batchAttendenceArray = mapElements;
				console.log(this.batchAttendenceArray);
			}
			// this.getDateTableHeader();
		})
	}

	clearFilter() {
		this.getAllAttendenceForBatch();
	}




}
